module.exports = {
          srcSet: __webpack_public_path__ + "20185f4d.jpg"+" 700w"+","+__webpack_public_path__ + "20445ef5.jpg"+" 1400w"+","+__webpack_public_path__ + "be78c76c.jpg"+" 1950w",
          images:[ {path: __webpack_public_path__ + "20185f4d.jpg",width: 700,height: 538},{path: __webpack_public_path__ + "20445ef5.jpg",width: 1400,height: 1077},{path: __webpack_public_path__ + "be78c76c.jpg",width: 1950,height: 1500}],
          src: __webpack_public_path__ + "20185f4d.jpg",
          toString:function(){return __webpack_public_path__ + "20185f4d.jpg"},
          
          width: 700,
          height: 538
        }